import axios from '../axios/index.js'

/**
 * 上传单个文件
 * @param {file} fileInfo 输入框获取的文件
 * @param {Object} that Vue 实例
 * @returns {({id: string, url: string})} 返回文件 id 和 url
 */
export const uploadFile = async (fileInfo, that) => {
  // eslint-disable-next-line no-irregular-whitespace
  let formData = new FormData()
  formData.append('file', fileInfo)

  const result = await axios.post('/api/upload/upload', formData, {
    // eslint-disable-next-line no-irregular-whitespace
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  if (result.data.code === 0) {
    return result.data.data
  } else {
    that.$message.error(result.data.msg)
    return Promise.reject(result.data)
  }
}
